const env = CONFIG_APP;
const port = env.port;
const slavePort = env.slavePort
env.apiUrl = `${env.url}:${port}/api/v1`;
env.apiUrl_2 = `${env.url}:${slavePort}/api/v1`;
env.version = "1.1.3";
export default env;
